import React, { useEffect, useState } from "react";
import "./WordViewer.css";

function WordViewer() {
  const [words, setWords] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [loading, setLoading] = useState(true);
  const [imageUrl, setImageUrl] = useState("");

  useEffect(() => {
    fetch(
      "https://s3napi.s3nsoftware.com/api/Quizzes/DetailedQuizz?id=2293"
    )
      .then((res) => res.json())
      .then((data) => {
        setWords(data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Fetch error:", err);
        setLoading(false);
      });
  }, []);

  if (loading) return <p>Loading...</p>;
  if (words.length === 0) return <p>No data available.</p>;

  const word = words[currentIndex];
  const audioSrc = word.audio?.replace("sound://", "https://s3nsoftware.com/");

  const handlePrev = () => {
    if (currentIndex > 0) setCurrentIndex(currentIndex - 1);
  };

  const handleNext = () => {
    if (currentIndex < words.length - 1) setCurrentIndex(currentIndex + 1);
  };

  return (
    <div className="viewer-container">
      <div className="alphabet-bg">
        {Array.from({ length: 50 }).map((_, i) => (
          <span
            key={i}
            className="letter"
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 10}s`,
              fontSize: `${Math.random() * 2 + 1}rem`,
            }}
          >
            {String.fromCharCode(65 + Math.floor(Math.random() * 26))}
          </span>
        ))}
      </div>
      <div className="word-card">
        <div style={{ display: "flex", flexDirection: "row" }}>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <h2 className="word-title">{word.Word}</h2>
            <p className="word-defn">{word.defn}</p>
          </div>
          <img
            src={word.ImageUrl}
            alt={word.Word}
            style={{
              width: "200px",
              height: "200px",
              objectFit: "cover",
              padding: "3px",
              borderRadius: "10px",
              border: "2px yellow solid",
            }}
          />
        </div>

        {audioSrc ? (
          <audio key={audioSrc} controls className="word-audio">
            <source src={audioSrc} type="audio/mpeg" />
            Your browser does not support the audio element.
          </audio>
        ) : (
          <p>No audio available</p>
        )}
      </div>

      <div className="nav-buttons">
        <button onClick={handlePrev} disabled={currentIndex === 0}>
          Previous
        </button>
        <span>{`${currentIndex + 1} / ${words.length}`}</span>
        <button
          onClick={handleNext}
          disabled={currentIndex === words.length - 1}
        >
          Next
        </button>
      </div>
    </div>
  );
}

export default WordViewer;
